/**
 * componentReact 事件监听组件
 */

import jsBridge from "../common/jsBridge";

/**
 * 普通 webview pageLoadFinish
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onWebviewLoad({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId,'onWebviewLoad', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * 通用组件的关闭按钮被点击
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onCloseBtnClicked({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId,'onCloseBtnClicked', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 pageLoadFinish
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onSubPlayTemplateViewLoad({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId,'onSubPlayTemplateViewLoad', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - endcard 阶段关闭按钮被点击
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onSubPlayTemplateViewCloseBtnClicked({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewCloseBtnClicked', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackPLAYSUCCESS({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewPlayStart',({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackPLAYFAILED({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewPlayFailed', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackPLAYCOMPLETED({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewPlayCompleted', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewEndcardShowSuccess', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackCLICKED({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewClicked', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}

/**
 * type 4 模板 - 开发者回调
 * @param {Object} eventFilter - 事件监听过滤器
 * @param {Object} eventFilter.expectCmptId - 指定要监听的 Component 实例 id
 * @param {Object} eventFilter.cb - Component 实例 id 匹配正确之后要执行的回调
 */
export function onComponentReactDeveloperCallbackDISMISSED({expectCmptId, cb}) {
    jsBridge.addComponentEventListener(expectCmptId, 'onSubPlayTemplateViewDismissed', ({id, data}) => {
        typeof cb === 'function' && cb({id, data})
    })
}